// extracted by mini-css-extract-plugin
export default {"image":"Image_image__FURD8","preview":"Image_preview__fMhpG"};